module.exports = __webpack_public_path__ + "img/menu-black.5b55203d.svg";